"use client";

import { FC, useState } from "react";

import { Blocks } from "@builder.io/sdk-react";

import { AnchorNavigation } from "@jti/ui/components/AnchorNavigation";
import { Typography } from "@jti/ui/components/Typography";
import { Container } from "@jti/ui/eva-components/Container";
import { formatDate } from "@jti/ui/utils/formatDate/formatDate";

import { useLocale } from "@/context/LocaleContext";
import { i18n } from "@/libs/i18n";

import { miscellanousPageContainerInputs } from "./MiscellaneousPageContainer.builder";

import styles from "./MiscellaneousPageContainer.module.scss";

type MiscellaneousPageContainerProps = BuilderComponentProps<
  typeof miscellanousPageContainerInputs
>;

export const MiscellaneousPageContainer: FC<
  MiscellaneousPageContainerProps
> = ({ builderBlock, title, date, sidebarBlocks, contentBlocks }) => {
  const [contentElement, setContentElement] = useState<HTMLDivElement | null>(
    null
  );
  const { currentLocale = i18n.defaultLocale } = useLocale();
  const formattedDate = formatDate(date, "DD MMMM YYYY", currentLocale);

  return (
    <Container>
      <div className={styles.page}>
        <div className={styles.heading}>
          <Typography variant="h1">{title}</Typography>
          {formattedDate && (
            <span className={styles.date}>{`[${formattedDate}]`}</span>
          )}
        </div>
        <div className={styles.content}>
          <div className={styles.sidebar}>
            <div className={styles.sidebarContent}>
              <div className={styles.anchorNavigation}>
                <AnchorNavigation
                  contentElement={contentElement}
                  targetSelector={"h2, h3"}
                />
              </div>

              <div className={styles.quickLinks}>
                <Blocks
                  parent={builderBlock?.id}
                  path={"quicklinks"}
                  blocks={sidebarBlocks}
                />
              </div>
            </div>
          </div>

          <main className={styles.main}>
            <div ref={(newContentRef) => setContentElement(newContentRef)}>
              <Blocks
                parent={builderBlock?.id}
                path={"content"}
                blocks={contentBlocks}
              />
            </div>

            <div className={styles.contentQuickLinks}>
              <Blocks
                parent={builderBlock?.id}
                path={"quicklinks"}
                blocks={sidebarBlocks}
              />
            </div>
          </main>
        </div>
      </div>
    </Container>
  );
};
